import React, { useContext } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import authContext from "../context/auth/authContext";
import bank from "../assets/images/bank.png";
import upi from "../assets/images/upi.jpg";
import NumberFormat from "react-number-format";
import cryptoContext from "../context/crypto/cryptoContext";
import { formatPrice } from "../helpers/format";

const FinalWithdrawModal = ({ close, details, isVpa, amount }) => {
  const { convt } = useContext(cryptoContext);
  const { loading, withDrawMoney, userData, walletData } =
    useContext(authContext);

  const handleWithdrawMoney = () => {
    withDrawMoney({
      pid: userData.profile_data._id,
      walletId: walletData._id,
      amount,
      currency: convt,
      paymentWithdrawMode: isVpa ? "vpa" : "bank_account", // In case of bank "bank_account"
      upiId: isVpa
        ? {
            username: userData.profile_data.username,
            handle: details.handle,
            address: details.address,
            razorpay_fund_acc_id: details.razorpay_fund_acc_id,
          }
        : {},
      // In case of bank select otherwise empty
      bankDetails: !isVpa
        ? {
            ifsc: details.ifsc,
            bank_name: details.bank_name,
            name: details.name,
            account_number: details.account_number,
            razorpay_fund_acc_id: details.razorpay_fund_acc_id,
          }
        : {},
    });
  };
  return (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={close}
          />
        </div>
        <div className="Register__content">
          <p>
            Withdrawing... &nbsp;
            <NumberFormat
              value={formatPrice(Number(amount))}
              displayType={"text"}
              thousandSeparator={true}
              prefix="₹"
            />
          </p>
          {details && (
            <>
              <div className="details_content"></div>
              <div className="details_content">
                <section className="Register__details">
                  {!isVpa && details && (
                    <div className="Register__bank">
                      <img src={bank} alt="bank_img" />

                      <div>
                        <p>{details.bank_name}</p>
                        <p>{details.account_number}</p>
                        <p>{details.name}</p>
                      </div>
                    </div>
                  )}

                  <div className="Register__details">
                    {isVpa && details && (
                      <div className="Register__upi">
                        <img src={upi} alt="upi_img" />
                        <div>
                          <p>{details.address}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </section>
              </div>
            </>
          )}
        </div>

        <div className="Register__social" style={{ marginTop: "10px" }}>
          <button
            className="Register__button"
            onClick={() => close}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
              background: "#EFF2F5",
              color: "#000",
            }}
          >
            CANCEL
          </button>
          <button
            className="Register__button"
            style={{
              marginRight: "10px",
              width: loading ? "140px" : "120px",
              borderRadius: "5px",
              display: "flex",
              flexDirection: "row",
            }}
            onClick={() => {
              // close();
              walletData && userData && handleWithdrawMoney();
            }}
            disabled={loading}
          >
            PROCEED{" "}
            {loading && (
              <div
                className="loader1"
                style={{
                  height: "20px",
                  width: "20px",
                  display: "inline-block",
                  border: "3px solid #f3f3f3",
                  borderTop: "3px solid #8d0792",
                  marginLeft: "5px",
                }}
              ></div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalWithdrawModal;
